namespace Matrix.Scheduling {
    export interface CalendarBaseForm {
        CalendarCode: FormatLookupEditor;
        BaseCalendarCode: FormatLookupEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class CalendarBaseForm extends Serenity.PrefixedContext {
        static formKey = 'Scheduling.CalendarBase';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CalendarBaseForm.init)  {
                CalendarBaseForm.init = true;

                var s = Serenity;
                var w0 = FormatLookupEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(CalendarBaseForm, [
                    'CalendarCode', w0,
                    'BaseCalendarCode', w0,
                    'Version', w1,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2
                ]);
            }
        }
    }
}
